export default {
  UAPI: '',
  CORPAPI: 'https://api-pre.intsig.net/corp', // 在未登录时，ip受限却取到localstorage（暂时）
  CORPAPIJP: 'https://ent-jp-pre.intsig.net/corp', // 日本代理
  CORPAPI2: 'https://corp2-pre.intsig.net/corp', // 在未登录时，多身份登录发送验证码
  UNSUBSCRIBE_AREA1: 'https://entpre1.camcard.com/corp/sync', // 退订 根据区域
  UNSUBSCRIBE_AREA2: 'https://entpre2.camcard.com/corp/sync',
  ENT_AREA1: 'https://entpre1.camcard.com/corp',
  ENT_AREA2: 'https://entpre2.camcard.com/corp',
  SyncAPI: 'https://entpre2.camcard.com/corp/sync',
  IntsigAPI: 'https://api-pre.intsig.net/', // 工具箱修改密码特殊使用
  SHARE_PAY_LINK_API: 'https://corp1-pre.intsig.net',
  API_USER: 'https://api-pre.intsig.net/user',
  QXBAPI: 'https://srh.intsig.net/CCAppService',
  PUBAPI: 'https://api-pre.intsig.net/cc_public'
  // UAPI: 'https://b12013.camcard.com/', // 需要修改
  // URL_BASE: 'https://b12013.camcard.com' // 跳转到旧系统链接的域名
  // 2000200: {
  //   UAPI: "",
  //   CORPAPI_NOLOGIN: "https://api-pre.intsig.net/corp",   // 在未登录时，ip受限却取到localstorage（暂时）
  //   CORPAPI: "https://corp1.intsig.net/corp",
  //   WebAPI: "https://a102.intsig.net",
  //   SiteAPI: "https://b102.camcard.com",
  //   TagAPI: "https://ent.intsig.net/corp/tag",
  //   MAPI: "https://cc-msg-eu.intsig.net/msg",
  //   ScanMsgAPI: "scanner-msg.intsig.net:5688",
  //   SearchAPI: "https://entpre1.camcard.com/corp/search",
  //   FSAPI: "https://d3038.intsig.net/corp/camfs",
  //   TaskAPI: "https://ent.intsig.net/corp/task",
  //   SAPI: "https://entpre1.camcard.com/corp/sync",
  //   SyncAPI: "https://entpre1.camcard.com/corp/sync",
  //   SAPI2: "https://d66.intsig.net/sync",
  //   NoteAPI: "https://ent.intsig.net/corp/note",
  //   ShareAPI: "https://entpre2.camcard.com/corp/sync"
  // },
  // 2000000: {
  //   UAPI: "",
  //   CORPAPI_NOLOGIN: "https://api-pre.intsig.net/corp",   // 在未登录时，ip受限却取到localstorage（暂时）
  //   FSAPI: "https://entpre2.intsig.net/corp/camfs",
  //   SearchAPI: "https://entpre2.intsig.net/corp/search",
  //   ScanMsgAPI: "scanner-msg.intsig.net:5688",
  //   MAPI: "https://cc-msg-us.intsig.net/msg",
  //   SAPI: "https://entpre2.intsig.net/corp/sync",
  //   CORPAPI: "https://corp2-pre.intsig.net/corp",
  //   SiteAPI: "https://bc104.camcard.com",
  //   SyncAPI: "https://entpre2.intsig.net/corp/sync",
  //   TagAPI: "https://entpre2.intsig.net/corp/tag",
  //   SAPI2: "https://d66.intsig.net/sync",
  //   WebAPI: "https://a104-pre.intsig.net",
  //   TaskAPI: "https://entpre2.intsig.net/corp/task",
  //   NoteAPI: "https://entpre2.intsig.net/corp/note",
  //   ShareAPI: "https://entpre2.camcard.com/corp/sync"
  // },
  // 1000000: {
  //   UAPI: "",
  //   CORPAPI: "https://corp1.intsig.net/corp",
  //   CORPAPI_NOLOGIN: "https://api-pre.intsig.net/corp",   // 在未登录时，ip受限却取到localstorage（暂时）
  //   WebAPI: "https://a102.intsig.net",
  //   SiteAPI: "https://b102.camcard.com",
  //   TagAPI: "https://ent.intsig.net/corp/tag",
  //   MAPI: "https://cc-msg.intsig.net/msg",
  //   ScanMsgAPI: "scanner-msg.intsig.net:5688",
  //   SearchAPI: "https://entpre1.camcard.com/corp/search",
  //   FSAPI: "https://ent.intsig.net/corp/camfs",
  //   TaskAPI: "https://ent.intsig.net/corp/task",
  //   SAPI: "https://entpre1.camcard.com/corp/sync",
  //   SyncAPI: "https://entpre1.camcard.com/corp/sync",
  //   SAPI2: "https://cc1.intsig.net/sync",
  //   NoteAPI: "https://ent.intsig.net/corp/note",
  //   ShareAPI: "https://entpre1.camcard.com/corp/sync"
  // },
  // default: {
  //   UAPI: "",
  //   CORPAPI_NOLOGIN: "https://api-pre.intsig.net/corp",   // 在未登录时，ip受限却取到localstorage（暂时）
  //   CORPAPI: "https://api-pre.intsig.net/corp",
  //   ShareAPI: "https://entpre2.camcard.com/corp/sync"
  // }
}
